/**
 * API 配置 - 生产环境统一走 api Cloud Function（完整 server.js），避免 404
 * 本地开发使用 localhost 后端
 */

// 检测是否为本地开发环境
const isLocalDev = process.env.NODE_ENV === 'development' || 
                   (typeof window !== 'undefined' && (
                     window.location.hostname === 'localhost' || 
                     window.location.hostname === '127.0.0.1'
                   ));

// 本地开发时使用统一的 localhost API URL
const LOCAL_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:9002';

// 生产环境使用 Firebase Functions（统一 api 入口，包含全部路由）
const FUNCTIONS_BASE_URL = process.env.REACT_APP_FUNCTIONS_BASE_URL || 
  'https://us-central1-linksbird-4fd3f.cloudfunctions.net';

// 全部走 api Cloud Function（包含 createAdsCampaign 等完整路由）
export const API_ENDPOINTS = {
  api: `${FUNCTIONS_BASE_URL}/api`,
};

/**
 * 线上完整回调地址（不受本地 dev 影响，用于页面说明、第三方配置）
 * 与生产环境 getApiUrl 的拼接方式一致：{FUNCTIONS}/api + path
 */
export const getProductionCallbackUrl = (path = "/api/postbackurl") => {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${FUNCTIONS_BASE_URL}/api${p}`;
};

// 辅助函数：根据路径返回正确的 API URL
export const getApiUrl = (path) => {
  // 本地开发环境：使用统一的 localhost API
  if (isLocalDev) {
    return `${LOCAL_API_URL}${path}`;
  }

  // 生产环境：全部走 api（独立 createAdsCampaign 有 googleAdsService 构造函数问题，改用 api 实现）
  return `${API_ENDPOINTS.api}${path}`;
};

export default API_ENDPOINTS;

